import dayjs from "dayjs";
import { capitalizeLetter } from "../../utils/capitalizeLetter";

const InvoicePrint = (data, watermark) => {
  const uniqueItems = [
    ...new Map(
      data?.invoice_items?.map((item, index) => [
        item?.product?.product_type?.size,
        item,
        index,
      ]),
    ).values(),
  ];

  const handlingMap = new Map();

  data?.invoice_items?.forEach((item) => {
    if (
      item.inbound_material_handling_fee_type === "custom" &&
      item.outbound_material_handling_fee_type === "custom"
    ) {
      handlingMap.set(
        "Inbound (Custom)",
        item.inbound_material_handling_fee_cost,
      );

      handlingMap.set(
        "Outbound (Custom)",
        item.outbound_material_handling_fee_cost,
      );
    } else {
      handlingMap.set(
        item.inbound_material_handling_fee_type
          ? capitalizeLetter(item.inbound_material_handling_fee_type)
          : "Free",
        item.inbound_material_handling_fee_cost ?? null,
      );
      handlingMap.set(
        item.outbound_material_handling_fee_type
          ? capitalizeLetter(item.outbound_material_handling_fee_type)
          : "Free",
        item.outbound_material_handling_fee_cost ?? null,
      );
    }
  });

  const uniqueMaterialHandlings = Array.from(handlingMap, ([type, cost]) => ({
    type,
    cost,
  }));

  return `<!DOCTYPE html>
<html lang="id">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${data?.invoice_number || "Detail Transaksi ELBE Group"}</title>
  <link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"
/>
  <style>
    @media print {
      @page {
        size: 9.5in 11in;
        margin: 10mm;
      }

      body {
        width: 9.5in;
        height: 11in;
      }
    }

    body {
      font-family: Arial, sans-serif;
      font-size: 10px;
      margin: 0;
      padding: 0;
      position: relative;
      height: 98vh;
    }

    body::before {
      content: "";
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-image: url('/logo.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 80%;
      opacity: 0.08;
      z-index: 0;
      transform: rotate(-30deg);
      pointer-events: none;
    }

    div {
      position: relative;
      z-index: 1;
    }

    .watermark {
      ${watermark}
    }

    h2 {
      text-align: center;
      font-size: 12px;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 5px;
      border: none;
    }

    th, td {
      border: 1px solid black;
      text-align: center;
      padding: 3px;
    }

    .footer {
      margin-top: 5px;
      font-size: 10px;
    }
  </style>
</head>
<body>
  <div>
    <h2>WMS ELBE GROUP</h2>
    <h2>DETAIL TRANSAKSI</h2>
    <h2>
      ${data?.invoice_number || "-"}
    </h2>
    <p style="font-size: 10px; font-weight:bold;">
      Tanggal: ${
        data?.invoice_items[0]?.outbound_date
          ? dayjs(data?.invoice_items[0].outbound_date).format("DD-MM-YYYY")
          : "-"
      }
    </p>
    <p style="font-size: 10px; font-weight:bold;">
      Customer: ${data?.client?.name || "-"}
    </p>

    <table cellspacing="0" cellpadding="0">
      <tr>
        <th rowspan="2">No</th>
        <th rowspan="2">Jenis Product</th>
        <th rowspan="2">Berat (kg)</th>
        <th rowspan="2">Tgl Masuk</th>
        <th rowspan="2" style="width: 50px;">Lama (Hari)</th>
        <th colspan="${uniqueItems.length}">Tarif Minimal</th>
        <th colspan="${uniqueItems.length}">Tarif Selanjutnya</th>
        <th colspan="2">Material Handling</th>
        <th rowspan="2">Total</th>
      </tr>
      <tr style="border: none;">
        ${uniqueItems
          .map(
            (e) =>
              `<td style="font-weight: bold;">${e?.product?.product_type?.size}</td>`,
          )
          .join("")}
        ${uniqueItems
          .map(
            (e) =>
              `<td style="font-weight: bold;">${e?.product?.product_type?.size}</td>`,
          )
          .join("")}
          <td style="font-weight: bold;">Inbound</td>
          <td style="font-weight: bold;">Outbound</td>
      </tr>


      ${data?.invoice_items
        ?.map(
          (e, index) => `
        <tr>
          <td>${index + 1}</td>
          <td style="text-align: left;">${e.product?.name || "-"}</td>
          <td>${Math.round(e.weight) || "-"}</td>
          <td>${
            e.inbound_date ? dayjs(e.inbound_date).format("DD-MM-YYYY") : "-"
          }</td>
          <td>${e.duration}</td>
          ${uniqueItems
            .map(
              (item) =>
                `<td>${
                  e?.product?.product_type?.size ===
                  item?.product?.product_type?.size
                    ? "Rp " +
                      (e?.first_week_fee * e.weight).toLocaleString("id-ID")
                    : ""
                }</td>`,
            )
            .join("")}
          ${uniqueItems
            .map(
              (item) =>
                `<td>${
                  e?.product?.product_type?.size ===
                    item?.product?.product_type?.size && e?.duration > 7
                    ? "Rp " +
                      (
                        e?.daily_fee *
                        e.weight *
                        (e?.duration - 7)
                      ).toLocaleString("id-ID")
                    : "-"
                }</td>`,
            )
            .join("")}
          <td>${
            e?.inbound_material_handling_fee_cost
              ? "Rp " +
                (
                  e?.inbound_material_handling_fee_cost * e.weight
                ).toLocaleString("id-ID")
              : "Free"
          } (${e?.inbound_material_handling_fee_type ?? "-"})</td>
            <td>${
              e?.outbound_material_handling_fee_cost
                ? "Rp " +
                  (
                    e?.outbound_material_handling_fee_cost * e.weight
                  ).toLocaleString("id-ID")
                : "Free"
            } (${e?.outbound_material_handling_fee_type ?? "-"})</td>
          <td>Rp ${(
            e?.amount + e?.total_material_handling_fee_cost
          ).toLocaleString("id-ID")}</td>
        </tr>
      `,
        )
        .join("")}

      <tr>
        <td colspan="5" rowspan="3" style="border: none; height: 1px;"></td>
        <td colspan="${
          2 + uniqueItems.length * 2
        }" style="text-align:center; font-weight:bold;">
          Total:
        </td>
        <td>Rp ${data?.invoice_items
          ?.reduce(
            (a, c) =>
              a +
              (Number(c?.amount || 0) +
                Number(c?.total_material_handling_fee_cost || 0)),
            0,
          )
          .toLocaleString("id-ID")}</td>
      </tr>
      <tr>
        <td colspan="${
          2 + uniqueItems.length * 2
        }" style="text-align:center; font-weight:bold;">
          ${data?.discount_percent ?? 0}% Diskon:
        </td>
        <td>Rp ${data?.discount_amount?.toLocaleString("id-ID") ?? 0}</td>
      </tr>
      <tr>
        <td colspan="${
          2 + uniqueItems.length * 2
        }" style="text-align:center; font-weight:bold;">
          Grand Total:
        </td>
        <td>Rp ${data?.grand_total?.toLocaleString("id-ID") ?? 0}</td>
      </tr>
    </table>

    <div class="footer">
      <p><strong>Keterangan:</strong></p>
      <p>
        *Tarif Minimal:
        ${uniqueItems
          .map(
            (e) =>
              ` ${e?.product?.product_type?.size} Rp ${e?.first_week_fee},- / Kg / 7 Hari Pertama;`,
          )
          .join("")}
      </p>
      <p>
        *Tarif Selanjutnya:
        ${uniqueItems
          .map(
            (e) =>
              ` ${e?.product?.product_type?.size} Rp ${e?.daily_fee},- / Kg / Hari;`,
          )
          .join("")}
      </p>
      <p>*Tarif Material Handling: ${uniqueMaterialHandlings
        .map((e) => {
          return `${e?.type} ${"Rp " + e?.cost + ",- / Kg;"} `;
        })
        .join("")}</p>
    </div>
  </div>
    <div style="margin-top:auto; padding-top: 100px">
      <div style="text-align: center; margin-top: 1rem; page-break-after: always;">
        <h2>
          Customer Service:
          <i class="fab fa-whatsapp"></i> 081225151232
          <i class="fas fa-globe"></i> https://www.lautanberkatfood.com/
          <i class="fas fa-envelope"></i> lautanberkatfood@gmail.com
        </h2>
      </div>
    </div>
</body>
</html>`;
};

export default InvoicePrint;
